import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class CompanyForm {
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      idDepartament: [null, Validators.required],
      idProvince: [{ value: null, disabled: true }, Validators.required],
      idDistrict: [{ value: null, disabled: true }, Validators.required],
      businessLine: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      urlBannerMiniPage: [File],
      ruc: [
        '',
        [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern(/^[0-9]+$/),
        ],
      ],
      commercialName: ['', Validators.required],
      legalName: ['', Validators.required],
    });
  }

  get idDepartament() {
    return this.form.get('idDepartament');
  }
  get idProvince() {
    return this.form.get('idProvince');
  }
  get idDistrict() {
    return this.form.get('idDistrict');
  }
  get businessLine() {
    return this.form.get('businessLine');
  }
  get email() {
    return this.form.get('email');
  }
  get ruc() {
    return this.form.get('ruc');
  }
  get commercialName() {
    return this.form.get('commercialName');
  }
  get legalName() {
    return this.form.get('legalName');
  }
}
